var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
var UrlValidatorDirective = /** @class */ (function () {
    function UrlValidatorDirective() {
        this.validator = this.validatUrlFactory();
    }
    UrlValidatorDirective_1 = UrlValidatorDirective;
    UrlValidatorDirective.prototype.validatUrlFactory = function () {
        return function (c) {
            if (c.value == null || c.value === '') {
                return null;
            }
            var REGEXP = /(https):\/\/([\w.]+\/?)\S*/;
            return REGEXP.test(c.value) ? null :
                { 'isWrong': true };
        };
    };
    UrlValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var UrlValidatorDirective_1;
    UrlValidatorDirective = UrlValidatorDirective_1 = __decorate([
        Directive({
            selector: '[validator-url][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return UrlValidatorDirective_1; }), multi: true }
            ]
        })
    ], UrlValidatorDirective);
    return UrlValidatorDirective;
}());
export { UrlValidatorDirective };
